/** @internal */
export function getDomEventFactory(eventName: string, attrName: string, preventDefault: boolean) {

    return ["$parse", ($parse) => {

        return {

            link: (scope, element, attrs) => {

                var fn = $parse(attrs[attrName]);

                element.bind(eventName, event => {
                    scope.$apply(() => {
                        if (preventDefault) event.preventDefault();
                        fn(scope, { $event: event });
                    });
                });

            }

        }

    }];

}
